import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import ReAuthModal from '@/components/ReAuthModal/index.vue';

import { useRoute } from 'vue-router';
import { ref, computed } from 'vue';
export default {
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    const language = ref("zh-cn");
    // const locale = computed(() => (language.value === 'zh-cn' ? 'zhCn' : 'en'))
    const size = computed(() => language.value === "zh-cn" ? "default" : "default");
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_sub_container = _resolveComponent("sub-container");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(zhCn),
        size: _unref(size)
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_component_router_view, null, null, 512), [[_vShow, _unref(route).name]]), _withDirectives(_createVNode(_component_sub_container, null, null, 512), [[_vShow, !_unref(route).name]]), _createVNode(ReAuthModal)]),
        _: 1
      }, 8, ["locale", "size"]);
    };
  }
};